import React from 'react';
import { styled } from 'linaria/react';
import { Intl } from '@jetshop/intl';
import { ReactComponent as SearchSvg } from '../../svg/Search.svg';
import { theme } from '../Theme';

const SearchContainer = styled('div')`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin-right: 14px;
  flex: 1;

  ${theme.below.lg} {
    min-width: unset;
    max-width: 100%;
    margin-bottom: 10px;
  }

  label {
    padding-left: 25px;
    margin-bottom: 0.25rem;
    display: block;
    font-size: 0.875rem;
    color: #707070;
  }

  input {
    width: 100%;
    height: 46px;
    padding: 0 48px 0 24px;
    font-size: 12px;
    /* border-radius: 27px; */
    border-radius: ${theme.button.desktop.borderRadius};
    border: 1px solid #e0e0e0;
    outline: none;

    font-family: 'Source Sans Pro', sans-serif;
  }

  svg {
    position: absolute;
    top: 14px;
    right: 20px;
    width: 1em;
    height: 1.2em;
  }
`;

const StoreSearch = ({ search, setSearch }) => (
  <SearchContainer>
    <Intl>
      {t => (
        <>
          {/* <label htmlFor="search-field">{t('Search')}</label> */}
          <input
            id="search-field"
            value={search}
            onChange={e => {
              setSearch(e.target.value);
            }}
            placeholder={t('Search for a reseller here')}
          />
        </>
      )}
    </Intl>
    <SearchSvg />
  </SearchContainer>
);

export default StoreSearch;
